import Vue from "vue";

export default {
    namespaced: true,
    state() {
        return {
            months: [
                {'name': Vue.prototype.$lang('month1'), 'value': '01'},
                {'name': Vue.prototype.$lang('month2'), 'value': '02'},
                {'name': Vue.prototype.$lang('month3'), 'value': '03'},
                {'name': Vue.prototype.$lang('month4'), 'value': '04'},
                {'name': Vue.prototype.$lang('month5'), 'value': '05'},
                {'name': Vue.prototype.$lang('month6'), 'value': '06'},
                {'name': Vue.prototype.$lang('month7'), 'value': '07'},
                {'name': Vue.prototype.$lang('month8'), 'value': '08'},
                {'name': Vue.prototype.$lang('month9'), 'value': '09'},
                {'name': Vue.prototype.$lang('month10'), 'value': '10'},
                {'name': Vue.prototype.$lang('month11'), 'value': '11'},
                {'name': Vue.prototype.$lang('month12'), 'value': '12'}
            ],
        }
    },
    getters: {
        years: state => {
            let max = new Date().getFullYear();
            let min = 900;
            const dates = [];

            for (let i = max; i >= min; i--) {
                dates.push(i);
            }

            return dates;
        },
        dates:  state => {
            const dates = [];

            for (let i = 1; i <= 31; i++) {
                let value = i < 10 ? '0'+ i : String(i);

                dates.push({'label' : i,'value': value});
            }
            return dates;
        },
        months: state => state.months,
    },
};
